import { Page, usePermissions } from '@/permissions';
import { FFR_MENU_VIEW_TAB } from '@/constants';

import { useFeatureFlag } from './useFeatureFlag';

type UseMenusPageAccess = {
  hasAccess: boolean;
  loading: boolean;
};

export const useMenusPageAccess = (): UseMenusPageAccess => {
  const { canAccess, loading: permissionsLoading } = usePermissions();
  const { enabled: featureFlagEnabled, loading: featureFlagLoading } =
    useFeatureFlag(FFR_MENU_VIEW_TAB);

  const loading = permissionsLoading || featureFlagLoading;
  const hasAccess = featureFlagEnabled && canAccess(Page.Menus) && !loading;

  return { hasAccess, loading };
};
